import { Info } from "@phosphor-icons/react";

const TEXT = {
  on_hold: {
    title: "Lifetime Access is on hold while PayPal reviews a payment query",
    body: "Your memories are safe. You can still view, download or delete everything you've recorded. Paid Life Seasons reopen automatically once PayPal confirms the outcome.",
  },
  refunded: {
    title: "Your Lifetime Access payment was refunded",
    body: "Your memories are safe. You can still view, download or delete everything you've recorded. To add new memories to paid Life Seasons, unlock Lifetime Access again.",
  },
};

export const AccessNotice = ({ notice, onUpgrade }) => {
  const t = TEXT[notice] || TEXT.refunded;
  return (
    <div data-testid="access-notice" className="flex flex-col gap-4 rounded-2xl border border-[#E06D53]/30 bg-gradient-to-r from-[#FFF4D6] to-[#FFE9C2] p-5 sm:flex-row sm:items-center">
      <Info size={28} weight="duotone" className="shrink-0 text-[#A84A32]" />
      <div className="flex-1">
        <p data-testid="access-notice-title" className="font-semibold text-[#2C2A28]">{t.title}</p>
        <p className="mt-1 text-sm leading-relaxed text-[#4A4540]">{t.body}</p>
      </div>
      {notice !== "on_hold" && (
        <button data-testid="access-notice-upgrade" onClick={onUpgrade}
          className="rounded-full bg-[#E06D53] px-6 py-3 text-sm font-semibold text-white hover:bg-[#C95A42]">
          Unlock again
        </button>
      )}
    </div>
  );
};
